const message = {
    upload: "Upload",
    loadingText: "loading",
    listText: "List",
    previewText: "Preview",
    uploadUser: "Upload user",
    uploadTime: "Upload time",
    totalCount: "total:{count}",
    dragText: "Drag",
    uploadFile: "Upload",
    dragTitle: "Drag files here to upload",
    dragTips: "Supported file formats: {accept}, single file size less than {size}M",
    uploading: "Uploading",
    documentName: "Document name",
    editDocumentName: "Edit document name",
    documentTips: "Do not modify the file extension, which may cause the file to not preview correctly",
    successDelete: "Success delete {name}",
    successEditFileName: "Save Success",
};

export default message;
